import { render, staticRenderFns } from "./ProductReservationWeekly.vue?vue&type=template&id=2beff57c&scoped=true"
import script from "./ProductReservationWeekly.vue?vue&type=script&lang=js"
export * from "./ProductReservationWeekly.vue?vue&type=script&lang=js"
import style0 from "./ProductReservationWeekly.vue?vue&type=style&index=0&id=2beff57c&prod&lang=stylus&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2beff57c",
  null
  
)

export default component.exports